<template>
  <button
    v-click-outside="() => { data.isOpen = false }"
    type="button"
    class="navi-button-dropdown"
    :class="{ 'is-open': data.isOpen }"
    @click="() => { data.isOpen = !data.isOpen }"
  >
    <slot
      name="label"
      :is-open="data.isOpen"
    >
      {{ props.label }}<NaviIconArrow :direction="data.isOpen ? 'up' : 'down'" />
    </slot>
    <div
      v-if="data.isOpen || props.shouldMountDropdown"
      v-show="data.isOpen"
      class="navi-button-dropdown-wrapper"
    >
      <div class="navi-button-dropdown-pointer" />
      <div class="navi-button-dropdown-content">
        <slot />
      </div>
    </div>
  </button>
</template>

<script setup>
import { reactive } from 'vue'

import vClickOutside from '@/directives/click-outside'

import NaviIconArrow from './NaviIconArrow.vue'

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  shouldMountDropdown: {
    type: Boolean,
    default: false,
  },
})

const data = reactive({
  isOpen: false,
})

</script>

<style scoped lang="scss">
.navi-button-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: content-box;
  outline: none;
  padding: 21px 0px 15px 12px;
  color: #636363;
  font-size: 15px;
  font-weight: bold;
  height: 18px;
  cursor: pointer;
  line-height: normal;
  white-space: nowrap;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;

  &:hover, &.is-active {
    color: #0386f4;
    background-color: transparent;
    position: relative;
    z-index: 1;
    border-left: none;
    text-decoration: none;
    &:not(.is-open) {
      border-bottom-color: #0386f4;
    }
  }
}
.navi-button-dropdown-wrapper {
  position: absolute;
  z-index: 5;
  top: calc(100% + 5px);
  left: -50%;
}
.navi-button-dropdown-pointer {
  display: block;
  width: 14px;
  height: 7px;
  position: absolute;
  top: 1px;
  left: 50%;
  &:before {
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    display: block;
    top: -14px;
    left: -14px;
    border: 14px solid transparent;
    border-top-width: 0;
    border-bottom-color: #dfdfdf;
  }
  &:after {
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    display: block;
    top: -12px;
    left: -12px;
    border: 12px solid transparent;
    border-top-width: 0;
    border-bottom-color: #fff;
  }
}
.navi-button-dropdown-content {
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 3px;
  background: rgb(255, 255, 255);
  border-width: 1px;
  border-style: solid;
  border-color: rgb(223, 223, 223);
  border-image: initial;
  border-radius: 3px;
  overflow: hidden;
  padding: 9px 0px;

  :deep(li) {
    border: none;

    a, button {
      width: 60px;
      color: #636363;
      padding: 0 15px;
      font-size: 15px;
      font-weight: bold;
      line-height: 36px;
      cursor: pointer;
      display: block;
      position: relative;
      white-space: nowrap;
      border: none;
      background: none;
      box-sizing: content-box;

      &:hover {
        color: #fff;
        background: #0386f4;
        text-decoration: none;
      }
    }
  }
}
</style>
